module.exports = __webpack_public_path__ + "static/media/button.48b92a9a.png";